import React, { useContext } from 'react'
import styles from './FormTitle.module.css'
import { BackButton } from '../CtaButton/BackButton'
import { StepIndexContext } from '../../Steps/StepContainer'
import { FormTitleProps } from './types'


export const FormTitle = ({
    formTitleText,
    dataViewLabel,
    dataClickLabel,
}: FormTitleProps) => {
    const stepIndex = useContext(StepIndexContext)

    return (
        <div className={styles.content}>
            {/* 1問目は戻る先が無いので出さない */}
            {stepIndex > 0 && <BackButton dataClickLabel={dataClickLabel} />}
            <div className={styles.title}>
                <h1
                    className={styles.titleText}
                    data-view-label={dataViewLabel}
                >
                    {formTitleText}
                </h1>
            </div>
        </div>
    )
}
